/**
 * Created by Zhangyanbo on 2017/2/16.
 */
import Vue from 'vue';
import tpl from './tpl.html';
import commonService from '../../../common/commonService';
import Loading from '../../../component/Loading.vue';
import Pager from '../../../component/Pager.vue';
import NoData from '../../../component/NoData.vue';
import ParseUrl from '../../../util/parseUrl';


export default Vue.extend({
    name: "blockInfo",
    template: tpl,
    components: {
        Loading,
        Pager,
        NoData
    },
    data(){
        return {
            block: {
                hash: '',//区块hash
                amount: '',//交易金额
                size: '',//区块大小
                num: '',//区块高度
                prize: '',//出块奖励
                tradeNum: '',//交易笔数
                signee: '', //产快代理
                fee: '',//手续费
                time: ''//出块时间
            },
            trade: {
                // amount:1

            },
            isLoading: false,
            param_hash: '',
            currentBlockNum: '',
            bigBlockNum: '',
            currentAddress: '',
            currentName: '',
            // currentBlockAcct:'',
            currentTradeParam: {},
            currentAccountName: '',
            condition: {
                pageNo: 1,
                pageSize: 10
            },
            pageNum: 0,
            currentUrlHash: '',
            isSpecialAcctName: false,
            tradeParam: ''
        }
    },
    created() {
        this.getUrlParam();
        var that = this;
        window.onhashchange = function () {
            that.getUrlParam();
        }
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    watch: {},
    methods: {
        /*
         * 获取地址栏中参数
         *
         * */
        getUrlParam(){
            window.scrollTo(0, 0);
            let tempParam = ParseUrl();
            if ('fromAddress' in tempParam) {
                this.param_hash = tempParam.fromAddress;
                this.currentAddress = tempParam.fromAddress;
                this.currentAccountName = '';
                this.currentTradeParam = {
                    'address': this.currentAddress,
                    'page': +this.condition.pageNo,
                    'per_page': this.condition.pageSize
                };

            } else if ('fromAcct' in tempParam) {
                this.currentAddress = tempParam.acctAddress;
                this.currentAccountName = tempParam.fromAcct;
                this.currentTradeParam = {
                    'address': this.currentAddress,
                    'page': +this.condition.pageNo,
                    'per_page': this.condition.pageSize
                };

            } else if ('fromAcctSpecial' in tempParam) {
                this.isSpecialAcctName = true;
                this.currentAccountName = tempParam.fromAcctSpecial;
                this.currentTradeParam = {
                    'account': this.currentAccountName,
                    'page': +this.condition.pageNo,
                    'per_page': this.condition.pageSize
                };
            }

            this.fetchTradeInfo();
        },

        /*
         * 通过区块hash显示查找交易信息
         *
         * */
        fetchTradeInfo() {
            this.isLoading = true;
            // let param = this.currentTradeParam;
            let param = this.currentTradeParam;
            commonService.tradeInfo(param).done((rep) => {
                let tempTrade = rep.result.data;
                this.pageNum = Math.ceil(rep.result.total / this.condition.pageSize);
                let that = this;
                tempTrade.forEach(function (value, index) {
                    let type = value.trx_type;
                    value.trx_type =
                        type == 0 ? '普通转账' :
                            type == 1 ? '代理领工资' :
                                type == 2 ? '账户注册' :
                                    type == 3 ? '注册代理' :
                                        type == 4 ? '升级代理' :
                                            type == 5 ? '更新账户' :
                                                type == 10 ? '合约注册' :
                                                    type == 11 ? '合约充值' :
                                                        type == 12 ? '合约升级' :
                                                            type == 13 ? '合约销毁' :
                                                                type == 14 ? '合约调用' :
                                                                    type == 15 ? '合约出账' : '';
                });

                for (var i = 0; i < tempTrade.length; i++) {
                    //通过地址查询更改账户名
                    let value = tempTrade[i];
                    if (!that.isSpecialAcctName) {
                        if (value.to_addr == that.currentAddress) {
                            that.currentAccountName = value.to_acct;
                            break;
                        } else if (value.from_addr == that.currentAddress) {
                            that.currentAccountName = value.from_acct;
                            break;
                        }
                    }
                }
                for (var i = 0; i < tempTrade.length; i++) {
                    let value = tempTrade[i];

                    //通过账户名查询账户地址
                    if (that.isSpecialAcctName) {
                        if (value.to_acct == that.currentAccountName) {
                            that.currentAddress = value.to_addr;
                            break;
                        } else if (value.from_acct == that.currentAccountName) {
                            that.currentAddress = value.from_addr;
                            break;
                        }
                    }
                }
                this.trade = tempTrade;
            }).fail((rep) => {
                window.error("网络异常，请稍后再试");

            }).always(() => {
                this.isLoading = false;
            });
        },

        /*
         * 通过账户地址查询交易信息
         *
         * */
        searchAccount(param) {
            this.currentAddress = param;
            this.condition.pageNo = 1;
            let that = this;
            setTimeout(function () {
                that.getUrlParam();
            }, 0)
        },

        /**
         * 分页
         * @param pageNo
         */
        changePage(pageNo) {
            // localStorage.SearchPageNo = +pageNo;
            this.condition.pageNo = +pageNo;
            this.currentTradeParam.page = +pageNo;
            this.currentTradeParam.per_page = this.condition.pageSize;
            this.fetchTradeInfo();
        }
    }
});





// WEBPACK FOOTER //
// ./src/module/index/searchResult/main.js